import { render, staticRenderFns } from "./booking-additional-informations.vue?vue&type=template&id=0c16f054"
import script from "./booking-additional-informations.vue?vue&type=script&lang=js"
export * from "./booking-additional-informations.vue?vue&type=script&lang=js"
import style0 from "./booking-additional-informations.vue?vue&type=style&index=0&id=0c16f054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports